import React, { useEffect, useState } from "react";
import '../../styles/mobilenumber.css'
import { Select } from "antd";
import DialCodes from "../../constants/DialCodes";
const MobileNumber = (props) => {
    const [contact, setContact] = useState('');
    const [code, setCode] = useState('');
    const [number, setNumber] = useState('');
    const [selectOptions,setSelectOptions] = useState([]);
    
    const onchangeCode = (value) => {
        setCode(value);
        setContact(value.replace('+','') + '-' + number);
        props.onChange(value.replace('+','') + '-' + number);
    }
    const onchangeNumber = (e) => {
        setNumber(e.target.value);
        setContact(code.replace('+','') + '-' + e.target.value)
        props.onChange(code.replace('+','') + '-' + e.target.value);
    }
    useEffect(() => {
        const setContactSections = () => {
            const valueArr = props.value && props.value !== '' ? props.value.split('-') : [];
            setCode(valueArr[0] ? '+'+valueArr[0] : '+91');
            setNumber(valueArr[1] ? valueArr[1] : '');
            setContact(props.value);
        }   
        setContactSections();
    }, [props.value]);
    useEffect(() => {
        setSelectOptions([]);
        if (selectOptions.length===0) {
            for (const c of DialCodes) {
                setSelectOptions(prev => [...prev, { label: c.dial_code, value: c.dial_code }]);
            }
        }
    },[])
    return (
        <div className="mobile-input-container">
            <span className="label"></span>
            <div className="input-container code-container">
                <Select style={{ width: 80 }} allowClear
                    options={[ ...selectOptions]} placeholder="Code"
                    optionFilterProp="children"
                    onChange={(value) => {
                        onchangeCode(value);
                    }}
                    value={code ? code : null}
                    defaultValue={code}
                    filterOption={(input, option) => (
                        option.label.toLowerCase().includes(input.toLowerCase())
                    )}/>
            </div>
            <div className="input-container number-container">
                <input type="text" inputMode="numeric" onChange={(e) => { onchangeNumber(e) }} maxLength={10}/>
            </div>
        </div>
    )
}
export default MobileNumber;